/** Define all api service names separated by feature */
export namespace ServiceNameEnum {
  export const auth = Object.freeze({
    login: '/api/v1/auth/login',
    logout: '/api/v1/auth/logout',
    refreshToken: '/api/v1/auth/refresh-token',
    test_users: '/api/v1/auth/users', // TODO will remove
  });

  export const authLine = Object.freeze({
    verifyAccessAccount: '/api/v1/chat/line/verifyAccessAccount',
    verifyAndSetUpWebHook: '/api/v1/chat/line/verifyAndSetUpWebHook',
  });

  export const authMessenger = Object.freeze({
    createAccessInformation: '/api/v1/chat/messenger/createAccessInformation',
  });

  export const authInstagram = Object.freeze({
    createAccessInformation: '/api/v1/chat/instagram/createAccessInformation',
  });

  export const chat = Object.freeze({
    index: '/api/v1/chat/listConnection',
    disconnected: '/api/v1/chat/disconnected',
    chatRoom: '/api/v1/admin-chat/rooms',
    chatHistory: '/api/v1/admin-chat/history/:id',
    note: '/api/v1/admin-chat/:id/add-note',
    updateNote: '/api/v1/admin-chat/chat-note/edit',
    deleteNote: '/api/v1/admin-chat/chat-note/:id',
    chatChannel: '/api/v1/admin-chat/channels',
    information: '/api/v1/admin-chat/information/:id',
    updateIsRead: '/api/v1/admin-chat/:id/isRead',
    websocket: '/api/v1/admin-chat/websocket',
  });

  export const me = Object.freeze({
    get: '/api/v1/me',
  });

  export const boUser = Object.freeze({
    index: '/api/v1/bo-user',
    activityLog: '/api/v1/activityLogs',
    get: '/api/v1/bo-user/:id',
    create: '/api/v1/bo-user/create',
    edit: '/api/v1/bo-user/edit/:id',
  });

  export const boRole = Object.freeze({
    index: '/api/v1/bo-role',
  });

  export const category = Object.freeze({
    index: '/api/v1/category',
    getByProductType: '/api/v1/categories/:productType',

  });

  export const partner = Object.freeze({
    index: '/api/v1/partner',
  });

  export const product = Object.freeze({
    index: '/api/v1/product',
    create: '/api/v1/product/create',
    importCode: '/api/v1/product/import-code',
    // updateImportStatus: '/api/v1/product/update-import-status',
    saveCode: '/api/v1/product/save-code',
    detail: '/api/v1/product/:id',
    edit: '/api/v1/product/edit/:id',
    // editCode: '/api/v1/product/edit-imported-code',
    delete: '/api/v1/product/delete/:id',
    getForCourse: '/api/v1/product/course',
    getRewardCodeBatch: '/api/v1/product/reward-code-batch/:productId',
  });

  export const file = Object.freeze({
    upload: '/api/v1/file',
  });

  export const customerMgmt = Object.freeze({
    index: '/api/v1/customer-mgmt/customers',
    activityList: '/api/v1/customer-mgmt/customer-activities/:id',
    detail: '/api/v1/customer-mgmt/customers/:id',
    delete: '/api/v1/customer-mgmt/customers/:id',
    deactivateAccount: '/api/v1/customer-mgmt/deactivate-account/:id',
    activateAccount: '/api/v1/customer-mgmt/activate-account/:id',
    update: '/api/v1/customer-mgmt/customers/:id',
    productList: '/api/v1/customer-mgmt/reward-code-redemptions/:id',
    uprankCoinList: '/api/v1/customer-mgmt/uprank-coin-transaction-items/:id',
    forgotPassword: '/api/v1/customer-mgmt/forgot-password',
    exportCustomer: '/api/v1/customer-mgmt/export-customer',
    voucher: '/api/v1/customer-mgmt/voucher/:customerId',
    createNonAppVoucher: '/api/v1/customer-mgmt/voucher/non-app/create/:customerId',
    deleteNonAppVoucher: '/api/v1/customer-mgmt/voucher/non-app/delete/:id',
    point: '/api/v1/customer-mgmt/point-transaction/:customerId',
    transactionDetail: '/api/v1/customer-mgmt/transaction-detail/:customerId',
    uploadTransactionDetail: '/api/v1/customer-mgmt/transaction-detail/upload',
    deleteTransactionDetail: '/api/v1/customer-mgmt/transaction-detail/:fileId',
    creditSummary: '/api/v1/customer-mgmt/credit-summary/:customerId',
    uploadCreditSummary: '/api/v1/customer-mgmt/credit-summary/upload',
    deleteCreditSummary: '/api/v1/customer-mgmt/credit-summary/:fileId',
    questionnaire: '/api/v1/customer-mgmt/questionnaire/:customerId',
    nonAppProduct: '/api/v1/customer-mgmt/voucher/non-app/products',
    approveAlumni: '/api/v1/customer-mgmt/approve-alumni/:id',
    rejectAlumni: '/api/v1/customer-mgmt/reject-alumni/:id',
    deleteCv: '/api/v1/customer-mgmt/:id/cv',
  });

  export const accessMethod = Object.freeze({
    index: '/api/v1/access-methods',
  });

  export const orderTransaction = Object.freeze({
    index: '/api/v1/transactionItem',
    detail: '/api/v1/transaction/:id',
    void: '/api/v1/transactions/:id/void',
    addNote: '/api/v1/transaction/:id/add-note',
    updateNote: '/api/v1/transaction/update-note',
    deleteNote: '/api/v1/transaction/delete-note/:id',
    cancelPending: '/api/v1/transaction/:id/cancel-pending',
    exportOrderTransaction: '/api/v1/transaction/export-transaction',
  });

  export const course = Object.freeze({
    index: '/api/v1/courses',
    create: '/api/v1/courses/create',
    detail: '/api/v1/courses/:id',
    edit: '/api/v1/courses/edit/:id',
    delete: '/api/v1/courses/delete/:id',
  });

  export const eventCode = Object.freeze({
    checkExistCode: '/api/v1/event-code/check-is-exist-code',
  });

  export const dashboard = Object.freeze({
    productList: '/api/v1/dashboard/product/list/:type',
    productDetail: '/api/v1/dashboard/product/detail',
  });

  export const notification = Object.freeze({
    index: '/api/v1/notifications',
    create: '/api/v1/notification/create',
    detail: '/api/v1/notification/:id',
    cancel: '/api/v1/notification/cancel/:id',
  });

  export const rearrange = Object.freeze({
    products: '/api/v1/products/rearrange',
    courses: '/api/v1/courses/rearrange',
    categoryRearrange: '/api/v1/categories/rearrange',
    productRearrange: '/api/v1/products/rearrange',
    courseRearrange: '/api/v1/courses/rearrange',
  });

  export const featuredBanner = Object.freeze({
    index: '/api/v1/featuredBanners',
    upload: '/api/v1/featuredBanner',
    delete: '/api/v1/featuredBanner/delete/:id',
  });

  export const voucher = Object.freeze({
    detail: '/api/v1/voucher/:id',
  });

  export const questionnaire = Object.freeze({
    index: '/api/v1/questionnaires',
    detail: '/api/v1/questionnaire/:id',
    delete: '/api/v1/questionnaires/:id',
    customerList: '/api/v1/questionnaires/customers',
    createPersonalInfo: '/api/v1/questionnaire/personalInfo/create',
    editPersonalInfo: '/api/v1/questionnaire/personalInfo/edit/:id',
    duplicationPersonalInfo: '/api/v1/questionnaires/personal-information/duplicate',
    labTestDetail: '/api/v1/questionnaires/:id/lab-test',

    getQuestionnaireHealth: '/api/v1/questionnaires/:id/healths',
    updateQuestionnaireHealth: '/api/v1/questionnaires/healths/:id',
    updateHealthFile: '/api/v1/questionnaires/health/:id/files',
    updateStatusHealthFile: '/api/v1/questionnaires/healths/:id/change-status',
    updateConsentStatusHealthFile: '/api/v1/questionnaires/healths/:id/update/consent-status',

    updateLabTestFile: '/api/v1/questionnaires/lab-tests/:id/files',
    updateStatus: '/api/v1/questionnaires/lab-tests/:id/change-status',

    getPreArrivalQuestionnaire: '/api/v1/questionnaires/:id/pre-arrivals',
    updateQuestionnairePreArrival: '/api/v1/questionnaires/pre-arrivals/:id',
    updateStatusQuestionnairePreArrival: '/api/v1/questionnaires/pre-arrivals/:id/change-status',

    getQuestionnaireMedical: '/api/v1/questionnaires/:id/medicals',
    updateQuestionnaireMedical: '/api/v1/questionnaires/medicals/:id',
    updateMedicalFile: '/api/v1/questionnaires/medical/:id/files',
    updateStatusMedicalFile: '/api/v1/questionnaires/medicals/:id/change-status',

  });

  export const event = Object.freeze({
    index: '/api/v1/events',
    detail: '/api/v1/events/:id',
    create: '/api/v1/events',
    edit: '/api/v1/events/:id',
    delete: '/api/v1/events/:id',
    registrations: '/api/v1/events/:id/registrations',
  });

  export const news = Object.freeze({
    index: '/api/v1/news',
    detail: '/api/v1/news/:id',
    create: '/api/v1/news',
    edit: '/api/v1/news/:id',
    delete: '/api/v1/news/:id',
  });

  export const featuredContent = Object.freeze({
    index: '/api/v1/featured-contents',
    detail: '/api/v1/featured-contents/:id',
    create: '/api/v1/featured-contents',
    edit: '/api/v1/featured-contents/:id',
    delete: '/api/v1/featured-contents/:id',
    publishedEvents: '/api/v1/featured-contents/events',
    publishedNews: '/api/v1/featured-contents/news',
  });

  export const report = Object.freeze({
    feedbackIndex: '/api/v1/reports/feedbacks',
    exportFeedback: '/api/v1/reports/feedbacks/export',
    chatIndex: '/api/v1/reports/chats',
    exportChat: '/api/v1/reports/chats/export',

  });

  export const jobs = Object.freeze({
    listByCustomer: '/api/v1/customer-mgmt/customers/:customerId/jobs',
    detail: '/api/v1/jobs/:id',
    update: '/api/v1/jobs/:id',
    close: '/api/v1/jobs/:id/close',
    delete: '/api/v1/jobs/:id',
  });
}
